// extracted by mini-css-extract-plugin
export default {"accordion":"styles__accordion--7-eBn"};